<template>
  <div>
    <div class="artdetail_top_bar">
      <span class="artdetail_tip artdetail_tip_noac" @click="goTome"
        >个人中心</span
      >
      <i class="el-icon-arrow-right"></i>
      <span class="artdetail_tip artdetail_tip_noac" @click="artmag"
        >文章管理</span
      >
      <i class="el-icon-arrow-right"></i>
      <span class="artdetail_tip">文章详情</span>
    </div>
    <div class="article_title_area">
      <span class="article_title">{{ articleTitle }}</span>
    </div>

    <div class="info_bar">
      <span class="source">{{ source }}</span>
      <span class="createTime">{{ createTime }}</span>
      <span class="labelName" v-for="label in this.kpArticleLabels">
        {{ label.labelName }}
      </span>
    </div>

    <div class="function_bar">
      <div>
        <img
          src="../assets/download.png"
          v-if="source === '本地上传'"
          class="download_text"
          @click="exportFileLocal(articleId)"
          @mouseover="showText"
          @mouseout="hideText"
        />
        <img
          src="../assets/download.png"
          v-else
          class="download_text"
          @click="exportFile(articleId)"
          @mouseover="showText"
          @mouseout="hideText"
        />
        <div class="text_container" v-show="isShowDownload">
          <p class="text_container_p">下载</p>
        </div>
      </div>
      <div v-if="!isShareMode">
        <img
          src="../assets/edit.png"
          class="edit_text"
          @click="edit(articleId)"
          @mouseover="showText"
          @mouseout="hideText"
        />
        <div class="text_container" v-show="isShowEdit">
          <p class="text_container_p">编辑</p>
        </div>
      </div>
      <div v-if="!isShareMode">
        <img
          src="../assets/share.png"
          class="share_text"
          @click="share(articleId)"
          @mouseover="showText"
          @mouseout="hideText"
        />
        <div class="text_container" v-show="isShowShare">
          <p class="text_container_p">分享</p>
        </div>
      </div>
    </div>

    <div
      v-if="source === '本地上传'"
      style="margin-top: 30px; width: 80%; height: 100%"
    >
      <iframe
        id="iframeId"
        ref="iframe"
        :src="uploadUrl"
        height="800px"
        width="1000px"
      />
    </div>

    <div v-else v-html="content"></div>
    <div>
      <div v-for="(file, index) in files" :key="index">
        <span>附件{{ index + 1 }}：</span>
        <a :href="file.url" :download="file.name" target="_blank">{{
          file.name
        }}</a>
      </div>
    </div>
    <!-- 分享选项弹窗 -->
    <div v-if="showShareOptionsModal" class="share-options-modal">
      <div class="share-option" @click="shareWithFriends">分享给好友</div>
      <div
        class="share-option"
        @click="
          () =>
            copyShareLink(
              currentArticleId,
              currentSource,
              currentLabels,
              currentCreateTime
            )
        "
      >
        分享链接
      </div>
      <div class="share-option" @click="closeShareOptionsModal">取消</div>
    </div>

    <!-- 好友列表弹窗 -->

    <div v-if="showFriendsListModal" class="friends-list-modal">
      <div class="list-section">
        <div class="section-title">好友</div>
        <div class="list-container">
          <div
            v-for="friend in friendsList"
            :key="friend.userId"
            class="friend-item"
          >
            <input type="checkbox" :value="friend" v-model="selectedFriends" />
            <!-- 添加选择框 -->
            <img class="fri_img" :src="friend.imageUrl" />
            <span class="friend_name">{{ friend.userName }}</span>
            <button @click="sendLinkToFriend(friend)">分享</button>
          </div>
        </div>
      </div>
      <!-- 群聊列表部分 -->
      <div class="list-section">
        <div class="section-title">团队</div>
        <div class="list-container">
          <div
            v-for="group in groupList"
            :key="group.groupId"
            class="friend-item"
          >
            <input type="checkbox" :value="group" v-model="selectedGroups" />
            <!-- 添加选择框 -->
            <span class="friend_name">{{ group.groupName }}</span>
            <button @click="sendLinkToGroup(group)">分享</button>
          </div>
        </div>
      </div>
      <!-- 最后再改这个一键分享 -->
      <!-- Container for action buttons -->
      <div class="friends-list-modal-actions">
        <button
          class="shareWithSelectedFriends"
          @click="shareWithSelectedFriends"
        >
          一键分享
        </button>
        <!-- One-click share button -->
        <div class="close-option" @click="closeFriendsListModal">取消</div>
        <!-- Cancel option -->
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
// import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import {
  exportToLocalPdf,
  exportToLocal,
  articleContent,
  articleInfo,
  shareArticleInfo,
  shareArticleContent,
  shareArticleDownload,
  receiveArticleInfo,
  receiveArticleContent,
} from "@/api/article";
import axios from "axios";
import { url } from "../api/request";
import { getTmpGroupList } from "@/api/chat";
import { GetFriendList, getFriendsByUseridAndKey } from "@/api/friend";
import { insertShareHistroy, findAllShareHistroy } from "@/api/shareHistory";
import {
  sendMessageInShare,
  sendGroupMessageInShare,
  sendSingleArticleMessage,
  sendGroupArticleMessage,
} from "../api/ws";
import { whoami } from "@/api/login";

export default {
  name: "artdetail",
  props: ["aid"],
  data() {
    return {
      index: 1,
      files: [],
      webviewStyles: {
        progress: {
          color: "#FF3333",
        },
      },
      articleId: null,
      articleTitle: "",
      articleType: "",
      content: "",
      createTime: "",
      source: "",
      updateTime: "",
      uploadUrl: "",
      kpArticleLabels: [],
      firstSort: [],
      secondSort: [],
      isShowDownload: false,
      isShowEdit: false,
      isShowShare: false,
      showShareOptionsModal: false, // 控制分享选项弹窗的显示
      showFriendsListModal: false, // 控制好友列表弹窗的显示
      selectedFriends: [], // 用于跟踪选中的好友
      currentArticleId: null,
      currentSource: "",
      currentLabels: "",
      currentCreateTime: "",
      friendsList: [],
      renderArtList: [],
      /* 群聊 */
      groupList: [],
      selectedGroups: [],
      currentArticleTitle: "",
      shareUrl: url + "/#/home/artdetail?aid=",
      userId: null,
      isShareMode: false,
      sendUid:1,
    };
  },
  created() {
    const { isShareMode } = this.$route.query;
    this.isShareMode = isShareMode;
    if (isShareMode) {
      return;
    }
    if (this.$store.state.msgContent.group.length == 0) {
      this.searchGroups();
    }
    whoami({}).then((res) => {
      this.userId = res.data.userId;
    });
  },
  mounted() {
    const query = this.$route.query;
    const { aid, isShareMode, authorId, isReceiveShareDetail, sendUid } = query;
    this.articleId = aid;
    this.sendUid = sendUid;
    if (isShareMode) {
      if (authorId === null || aid === null) {
        this.$message.error("分享链接不完整");
        return;
      }
      shareArticleInfo({
        articleId: aid,
        authorId: authorId,
      }).then((res) => {
        const { data } = res;
        this.articleTitle = data.articleTitle;
        this.articleType = data.articleType;
        this.content = data.content;
        this.createTime = data.createTime;
        this.source = data.source;
        this.updateTime = data.updateTime;
        this.kpArticleLabels = data.kpArticleLabels;
        this.firstSort = data.firstSort;
        this.secondSort = data.secondSort;
        this.initUrl(this.articleId, authorId, isShareMode);
      });
      return;
    }
    if (isReceiveShareDetail) {
      if (authorId === null || aid === null) {
        this.$message.error("文章不存在");
        return;
      }
      receiveArticleInfo({
        sendUid: this.sendUid,
        articleId: aid,
      }).then((res) => {
        const { data } = res;
        this.articleTitle = data.articleTitle;
        this.articleType = data.articleType;
        this.content = data.content;
        this.createTime = data.createTime;
        this.source = data.source;
        this.updateTime = data.updateTime;
        this.kpArticleLabels = data.kpArticleLabels;
        this.firstSort = data.firstSort;
        this.secondSort = data.secondSort;
       
        this.initUrl(this.articleId,0, false,true);
      });
      return;
    }

    articleInfo({
      articleId: this.articleId,
    }).then((res) => {
      console.log("@@@@@@@@@@@@@");
      console.log(res);
      var data = res.data;
      this.articleTitle = data.articleTitle;
      this.articleType = data.articleType;
      this.content = data.content;
      this.createTime = data.createTime;
      this.source = data.source;
      this.updateTime = data.updateTime;
      this.kpArticleLabels = data.kpArticleLabels;
      this.firstSort = data.firstSort;
      this.secondSort = data.secondSort;
      this.initUrl(this.articleId);
    });

    if (!this.articleId) {
      this.$router.push({
        name: "artmag",
      });
    }
  },
  methods: {
    showText(e) {
      if (e.target["className"] == "download_text") {
        this.isShowDownload = true;
      } else if (e.target.className == "edit_text") {
        this.isShowEdit = true;
      } else if (e.target.className == "share_text") {
        this.isShowShare = true;
      } else {
      }
    },
    hideText() {
      this.isShowDownload = false;
      this.isShowEdit = false;
      this.isShowShare = false;
    },
    artmag() {
      var that = this;
      that.$router.push({
        name: "artmag",
        params: {
          refresh: true,
        },
      });
    },
    goTome() {
      this.$router.push({
        name: "me",
      });
    },
    kindeditorChange(val) {
      console.log(val);
    },
    initUrl(articleId, authorId, isShareMode,isReceiveShareDetail2) {
      if (isShareMode) {
        shareArticleContent({
          authorId,
          articleId,
        }).then((res) => {
          this.uploadUrl = res.data.url;
          if (res.data.type) {
            this.uploadUrl =
              "https://www.pfile.com.cn/api/profile/onlinePreview?url=" +
              encodeURIComponent(res.data.url);
          }
          this.files = res.data.fileList;
        });
        return;
      }

      if (isReceiveShareDetail2) {
        // 获取文章的附件
        receiveArticleContent({
          sendUid: this.sendUid,
          articleId: articleId,
        }).then((res) => {
          console.log("------------------------");
          console.log(res.data);
          this.uploadUrl = res.data.url;
          if (res.data.type) {
            this.uploadUrl =
              "https://www.pfile.com.cn/api/profile/onlinePreview?url=" +
              encodeURIComponent(res.data.url);
          }
          this.files = res.data.fileList;
          console.log(this.uploadUrl);
        });
        return;
      }
      // 获取文章的附件
      articleContent({
        articleId: articleId,
      }).then((res) => {
        console.log("------------------------");
        console.log(res.data);
        this.uploadUrl = res.data.url;
        if (res.data.type) {
          this.uploadUrl =
            "https://www.pfile.com.cn/api/profile/onlinePreview?url=" +
            encodeURIComponent(res.data.url);
        }
        this.files = res.data.fileList;
        console.log(this.uploadUrl);
      });
    },
    exportFile(articleId) {
      console.log(articleId);
      this.downloadFileAsync(articleId);
    },
    exportFileLocal(articleId) {
      console.log(articleId);
      this.downloadFileLocalAsync(articleId);
      // loadingInstance.close(); // 关闭加载状态
    },
    edit(articleId) {
      const data = {
        url: this.uploadUrl,
        firstLevelClassId: this.firstSort.sortId,
        secondLevelClassId: this.secondSort.sortId,
        // tags : this.kpArticleLabels,
        articleId: this.articleId,
        articleTitle: this.articleTitle,
        articleType: this.articleType,
        content: this.content,
        // html : this.html,
        source: this.source,
        createTime: this.createTime,
        collectionTime: this.updateTime,
        // collectionProcess : this.collectionProcess,
        fileList: this.files,
      };
      this.$store.dispatch("recordData", data);
      // 处理 tags
      this.$store.dispatch(
        "getTagsAndActiveSome",
        this.kpArticleLabels.map((item) => item.labelId)
      );

      this.$router.push({
        name: "artedit",
        params: {
          refresh: true,
          artdetail: true,
          articleSource: this.source,
        },
      });
    },
    share(articleId) {
      this.showShareOptionsModal = true;
      this.currentArticleId = articleId; // 保存当前文章ID
    },
    shareWithFriends() {
      this.showShareOptionsModal = false;

      this.searchFriends();
      this.searchGroups();
    },
    searchFriends() {
      var that = this;
      this.loading = true;
      GetFriendList()
        .then((response) => {
          console.log(response.data);
          that.friendsList = response.data; // 使用搜索结果更新列表
          // 在这里进行是否显示好友列表模态框的逻辑判断
          if (that.friendsList.length === 0) {
            // 如果好友列表为空，则弹窗提示用户先添加好友
            that.$message({
              message: "您现在没有好友，请添加好友",
              type: "error",
            });
          } else {
            // 有好友时显示好友列表模态框
            that.showFriendsListModal = true;
          }
        })
        .catch((error) => {
          console.error("获取好友出错:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchGroups() {
      var that = this;
      this.loading = true;
      getTmpGroupList({
        userId: 1,
      })
        .then((response) => {
          that.groupList = response.rows; // 使用搜索结果更新列表
          that.$store.state.msgContent.group = response.rows;
        })
        .catch((error) => {
          console.error("搜索好友出错:", error);
        });
    },
    /* http://localhost:8081/#/home/artdetail/606
			   http://47.105.45.11:9000/kp-1/606/606.html
			   线上：http://47.105.45.11/#/home/artdetail?aid=784&asource=%E9%9D%92%E6%98%A5%E5%B1%B1%E4%B8%9C
			   http://localhost:8083/#/home/artdetail?aid=1019
			*/
    getShareUrl(articleId, source, akpArticleLabels, acreateTime) {
      // 基础 URL，您可以根据需要更改此 URL
      const baseNewUrl = url.replace(/\/api$/, "") + "/#/home/";

      const shareUrl = `${baseNewUrl}artdetail?aid=${articleId}`;

      return shareUrl;
    },

    copyShareLink(articleId, source, labels, time) {
      // 定义新的基础URL
      const shareUrl = this.getShareUrl(articleId, source, labels, time);
      // 调用复制到剪贴板的函数
      this.copyToClipboardAsLink(shareUrl);
      /* this.$copyText(shareUrl).then(
			    () => {
			      this.$message({
			        message: "分享链接已复制到剪贴板",
			        type: "success",
			      });
			    },
			    () => {
			      this.$message({
			        message: "分享链接复制失败",
			        type: "error",
			      });
			    }
			  ); */
    },
    // 这个函数会复制文本作为超链接到剪贴板
    // 注意：这种方法可能在某些环境下不起作用，因为它依赖于目标应用如何处理HTML内容
    copyToClipboardAsLink(text) {
      const tempInput = document.createElement("input");
      document.body.appendChild(tempInput);
      tempInput.value = text;
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);

      // 可选：显示一个提示，通知用户链接已复制
      this.$message({
        message: "分享链接已复制到剪贴板",
        type: "success",
      });
    },
    shareWithSelectedFriends() {
      if (
        this.selectedFriends.length === 0 &&
        this.selectedGroups.length === 0
      ) {
        this.$message({
          message: "请选择至少一个好友进行分享",
          type: "warning",
        });
        return;
      }

      this.selectedFriends.forEach((friend) => {
        this.sendLinkToFriend(friend); // 使用已有的发送链接方法
      });
      this.selectedGroups.forEach((group) => {
        this.sendLinkToGroup(group); // 使用已有的发送链接方法
      });
      this.$message({
        message: "已成功分享给好友聊天",
        type: "success",
      });

      // 分享后重置选中的好友列表
      this.selectedFriends = [];
      this.selectedGroups = [];
      // 可选：关闭好友列表模态框
      this.closeFriendsListModal();
    },
    convertUrlsToLinks(text) {
      // 使用正则表达式查找URL
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, function (url) {
        return '<a href="' + url + '" target="_blank">' + url + "</a>";
      });
    },
    sendLinkToFriend(friend) {
      // 发送链接给好友的逻辑
      // 构造要发送的数据
      // 定义新的基础URL
      const shareUrl = this.getShareUrl(
        this.currentArticleId,
        this.currentSource,
        this.currentLabels,
        this.currentCreateTime
      );
      /* let shareUrls = this.convertUrlsToLinks(shareUrl);
			  "【知识阁-文章分享】" + this.currentArticleTitle + " " +
			  */
      sendSingleArticleMessage(
        shareUrl,
        this.userId,
        "【知识阁-文章分享】 " + this.currentArticleTitle + " ",
        friend.userId
      );
      const data = {
        articleId: this.currentArticleId,
        articleTitle: this.currentArticleTitle, // 当前文章标题
        friendName: friend.userName, // 好友的名字
        createTime: new Date().toISOString(), // 当前时间的 ISO 字符串
        receiveUid: friend.userId,
      };
      insertShareHistroy(data)
        .then((response) => {
          this.$message({
            message: "分享好友成功",
            type: "success",
          });
          // 处理响应
          console.log(`链接已发送给 ${friend.userName}`);
          // 这里可以添加一些用户反馈，比如显示一个通知或者消息
        })
        .catch((error) => {
          // 处理错误
          console.error("发送链接失败:", error);
          // 这里可以添加错误处理，比如显示错误消息
        });
      console.log(`链接已发送给 ${friend.userName}`);
    },
    sendLinkToGroup(group) {
      // 发送链接给好友的逻辑
      // 构造要发送的数据
      // 定义新的基础URL
      const shareUrl = this.getShareUrl(
        this.currentArticleId,
        this.currentSource,
        this.currentLabels,
        this.currentCreateTime
      );
      /* let shareUrls = this.convertUrlsToLinks(shareUrl); */
      sendGroupArticleMessage(
        shareUrl,
        this.userId,
        "【知识阁-文章分享】 " + this.currentArticleTitle + " ",
        group.groupId
      );
      this.$message({
        message: "分享团队成功",
        type: "success",
      });
      //要把这个分享插进分享记录里
    },
    closeShareOptionsModal() {
      this.showShareOptionsModal = false;
    },

    closeFriendsListModal() {
      this.showFriendsListModal = false;
    },

    async downloadFileAsync(articleId) {
      const { isShareMode, authorId } = this.$route.query;
      let loadingInstance;
      try {
        loadingInstance = this.$loading({
          lock: true, // 是否锁定背景滚动，默认为 false
          text: "下载中", // 显示的文本内容
          spinner: "el-icon-loading", // 加载图标
          background: "rgba(255, 255, 255, 0.7)", // 遮罩层背景色
        });
        let response;
        if (isShareMode) {
          response = await shareArticleDownload({
            articleId: articleId,
            authorId: authorId,
          });
        } else {
          response = await exportToLocalPdf({
            articleId: articleId,
          });
        }
        console.log(response);
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const downloadLink = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = this.source + "-" +  this.articleTitle + ".pdf";

        document.body.appendChild(downloadLink);
        downloadLink.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(downloadLink);

        loadingInstance.close(); // 关闭加载状态
      } catch (err) {
        console.error("Error downloading file:", err);
        loadingInstance.close(); // 关闭加载状态
      }
    },
    async downloadFileLocalAsync(articleId) {
      try {
        const loadingInstance = this.$loading({
          lock: true, // 是否锁定背景滚动，默认为 false
          text: "下载中", // 显示的文本内容
          spinner: "el-icon-loading", // 加载图标
          background: "rgba(255, 255, 255, 0.7)", // 遮罩层背景色
        });
        // 发起HTTP GET请求以获取后端文件数据
        const response = await exportToLocal({
          articleId: articleId,
        });

        console.log(response); // 确认response对象是否被正确地初始化
        if (response.headers["content-type"]) {
          console.log(response.data);

          // 获取后端传递的文件类型
          const contentType = response.headers["content-type"];

          // 创建一个Blob对象
          console.log(contentType);
          const blob = new Blob([response.data], {
            type: contentType,
          });

          // 创建一个虚拟的链接元素
          const link = document.createElement("a");
          const url = window.URL.createObjectURL(blob);
          link.href = url;
          link.target = "_blank"; // 在新标签页中打开链接
          link.download = this.source + "-" +  this.articleTitle; // 设置下载的文件名
          document.body.appendChild(link);

          // 触发点击事件来开始下载
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);

          loadingInstance.close(); // 关闭加载状态
        }
      } catch (error) {
        console.error("下载文件时出错：", error);
        loadingInstance.close(); // 关闭加载状态
      }
    },
  },
};
</script>

<style>
.artdetail_tip_noac {
  color: #707070 !important;
}

.artdetail_tip {
  font-size: 18px;
  color: #2683be;
  cursor: pointer;
}

.artdetail_top_bar {
  display: flex;
  align-items: center;
}

.function_bar {
  margin-top: 15px;
  padding: 10px;
  width: 100%;
  display: flex;
  justify-content: right;
  position: relative;
}

.download_text {
  width: 50px;
  margin-right: 30px;
}

.edit_text {
  width: 50px;
  margin-right: 30px;
}

.share_text {
  width: 50px;
}

.info_bar {
  padding-top: 20px;
}

.source {
  color: #808080;
  font-size: 18px;
}

.createTime {
  color: #c39c61;
  font-size: 18px;
  margin-left: 35px;
}

.labelName {
  color: #ffffff;
  font-size: 15px;
  font-weight: 500;
  margin-left: 35px;
  background-color: #2683be;
  padding: 5px;
}

.article_title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.article_title_area {
  margin-top: 20px;
}

.text_container {
  position: absolute;
  width: 40px;
  height: 10px;
  top: 45px;
  /* left: 870px; */
  background-color: rgba(0, 0, 0, 0);
  color: #fff;
  text-align: center;
  padding-top: 20px;
  padding-left: 5px;
  z-index: 1;
}

.text_container_p {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  color: #1296db;
}
</style>
